import ProvisionalReceiptProductConfig from './ProvisionalReceiptProductConfig';

export default ProvisionalReceiptProductConfig;